import { DASHBOARD_EMPTY_STATE } from "../../constants";
import { CHART_MIN_HEIGHT } from "../../utils/operatorDashboardCharts";
import op from "./OperatorDashboardView.module.css";

const OperatorChartCard = ({
  title,
  subtitle,
  trailing,
  loading,
  hasData,
  children,
  bare = false,
}) => {
  const titleId = title
    ? `chart-${title.replace(/\s+/g, "-")}`
    : "chart-panel";

  const content = loading ? (
    <div className={op.emptyState} style={{ minHeight: CHART_MIN_HEIGHT }}>
      Loading…
    </div>
  ) : hasData ? (
    children
  ) : (
    <div className={op.emptyState} style={{ minHeight: CHART_MIN_HEIGHT }}>
      {DASHBOARD_EMPTY_STATE}
    </div>
  );

  if (bare) {
    return <div className={op.chartBody}>{content}</div>;
  }

  return (
    <article className={op.chartPanel} aria-labelledby={titleId}>
      {(title || trailing) && (
        <div className={op.chartPanelHeader}>
          <div>
            {title && (
              <h3 id={titleId} className={op.chartPanelTitle}>
                {title}
              </h3>
            )}
            {subtitle && <p className={op.chartPanelSubtitle}>{subtitle}</p>}
          </div>
          {trailing}
        </div>
      )}
      <div className={op.chartBody}>{content}</div>
    </article>
  );
};

export default OperatorChartCard;
